import { Injectable, inject, signal } from '@angular/core';
import { EMPTY, Subscription, catchError, switchMap, timer } from 'rxjs';
import { SystemSchedulerService } from './system-scheduler.service';

/**
 * Pollt den aggregierten Scheduler-Problem-Status (Fehlerserien + überfällige
 * Jobs) für das Nav-Badge der System-Admins. Start/Stop steuert das
 * Default-Layout anhand der System-Admin-Rolle (Login/Logout). Transiente
 * Fehler beenden das Polling nicht (catchError im inneren Stream — Muster
 * Scheduler-Auto-Refresh).
 */
@Injectable({ providedIn: 'root' })
export class SchedulerStatusService {
  private readonly scheduler = inject(SystemSchedulerService);
  private sub: Subscription | null = null;

  /** Anzahl Jobs mit Fehlerserie ODER Worker-fehlt-Verdacht (distinct). */
  readonly problemCount = signal(0);

  startPolling(): void {
    if (this.sub) return;
    this.sub = timer(0, 60_000)
      .pipe(switchMap(() => this.scheduler.status().pipe(catchError(() => EMPTY))))
      .subscribe((s) => this.problemCount.set(s.problemGesamt));
  }

  stopPolling(): void {
    this.sub?.unsubscribe();
    this.sub = null;
    this.problemCount.set(0);
  }
}
